import React from 'react';
import styled from 'styled-components';
import { colors, sizes } from 'styles/variables';
import radio_1 from '../../static/radio_1.svg';
import radio_0 from '../../static/radio_0.svg';

export default props => {
	const Wrapper = styled.div`
		display: grid;
		grid-template-columns: auto 1fr auto 1fr auto;
		margin-bottom: ${sizes[4]};
		align-items: center;
		height: 22px;
	`;
	const ProgressWrapper = styled.div`
		height: 4px;
		margin-top: -2px;
		margin-left: -5px;
		margin-right: -5px;
		background: ${colors.background[2]};
		border-radius: 10px;
		position: relative;
		display: grid;
		grid-template-colummns: repeat(3, 1fr);
		z-index: -1;
	`;
	const ProgressBar = styled.div`
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		background: ${colors.teal.base};
		border-radius: 10px;
	`;
	const Tooltip = styled.div`
		display: inline-block;
		background: ${colors.teal.base};
		border-radius: ${sizes[0]};
		color: ${colors.background[0]};
		font-size: 0.7rem;
		font-weight: bold;
		padding: 5px;
		position: absolute;
		left: 100%;
		top: 10px;
		width: 40px;
		transform: translateX(-50%);
		&:before {
			content: '';
			position: absolute;
			bottom: 100%;
			left: 50%;
			transform: translateX(-50%);
			display: block;
			width: 0;
			height: 0;
			border-style: solid;
			border-width: 0 4px 4px 4px;
			border-color: transparent transparent ${colors.teal.base} transparent;
		}
	`;
	return (
		<Wrapper>
			<div>
				<img src={radio_1} alt="checked checkbox" />
			</div>
			<ProgressWrapper>
				<ProgressBar style={{ width: `calc(${props.current} / ${props.total} * 100%)` }}>
					<Tooltip>
						{props.current}/{props.total}
					</Tooltip>
				</ProgressBar>
			</ProgressWrapper>
			<div>
				<img src={radio_0} alt="unchecked checkbox" />
			</div>
			<ProgressWrapper />
			<div>
				<img src={radio_0} alt="unchecked checkbox" />
			</div>
		</Wrapper>
	);
};
